<template>
	<div class="basic-info">
		<p class="title">
			车辆概况
		</p>
		<div>
			<div v-for="item in overview" class="info-row">
				<div>
					{{ item.label }}
				</div>
				<div>
					{{ item.value }}
				</div>
			</div>
		</div>
		<p class="title mt40">
			车辆配置信息
		</p>
		<!-- <div>
			<div v-for="item in baseInfo" class="info-row">
				<div>
					{{ item.label }}
				</div>
				<div>
					{{ item.value }}
				</div>
			</div>
		</div> -->
		<div>
			<div v-for="item in allConfigs" class="configs">
				<div class="config">
					<div class="info">
						<nio-image class="img" :src="item.url" />
						<div class="name">
							{{ item.name }}
						</div>
					</div>
					<div class="price">
						<template v-if="!hasPrice(item.price)">非加价获得</template>
						<template v-else>
							<div>加价获得</div>
							<div>¥{{ formatPrice(item.price) }}</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<!-- <template v-if="highlight && highlight.length">
			<p class="title mt40">
				配置亮点
			</p>
			<div>
				<div v-for="item in highlight" class="info-row">
					<div>
						{{ item.category }}
					</div>
					<div>
						{{ item.value }}
					</div>
				</div>
			</div>
		</template> -->
	</div>
</template>

<script>
import util from '@/util/util'

export default {
	name: 'BasicInfo',
	props: ['car'],
	computed: {
		allConfigs() {
			if (this.car && this.car.basic) {
				return this.car.basic.all_configs || []
			}
			return []
		},
		overview() {
			return [
				{
					label: '综合续航里程（km）',
					value: this.car.basic.comprehensive_mileage
						? util.formatBigNumber(this.car.basic.comprehensive_mileage)
						: '-'
				},
				{
					label: '表显里程（km）',
					value: this.car.basic.mileage ? util.formatBigNumber(this.car.basic.mileage) : '-'
				},
				{
					label: '交强险到期',
					value: this.car.basic.compulsory_insurance_expired_date
						? util.formatDate(this.car.basic.compulsory_insurance_expired_date * 1000)
						: '-'
				},
				{
					label: '年检到期',
					value: this.car.basic.yearly_inspection_expired_date
						? util.formatDate(this.car.basic.yearly_inspection_expired_date * 1000)
						: '-'
				}
			]
		},
		highlight() {
			return this.car.highlight_config || []
		}
	},
	methods: {
		hasPrice(price) {
			return Number(price) > 0
		},
		formatPrice(price) {
			return (Number(price) || 0).toLocaleString()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.basic-info {
	margin-top: 30px;
	.title {
		@include subtitle_1(1, 400, false);
		color: #040b29;
		margin-bottom: 20px;
		font-size: 18px;
	}
	.mt40 {
		margin-top: 40px;
	}

	.finance-info {
		margin-top: 60px;
		.finance-content {
			margin-top: 30px;
			@include body_2(1.5, 400, false);
			color: $text_primary;
		}
	}

	.configs {
		.config {
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.info {
				display: flex;
				align-items: center;

				font-size: 14px;
				color: rgba(5, 11, 39, 1);
				line-height: 19.6px;
				.img {
					width: 46px;
					height: 46px;
					border-radius: 50%;
					overflow: hidden;
					margin-right: 10px;
				}
				.name {
					flex: 1;
				}
			}

			.price {
				width: 100px;
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				justify-content: center;
				font-size: 14px;
				line-height: 21px;
				color: rgba(104, 109, 130, 1);
			}
		}
	}

	.info-row {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		@include body_2(1.5, 400, false);

		&:not(:last-child) {
			margin-bottom: 20px;
		}
		> :first-child {
			color: $text_secondary;
		}

		> :last-child {
			max-width: 58%;
			text-align: end;
			color: $text_primary;
		}
	}
}
</style>
